// extracted by mini-css-extract-plugin
export default {"srOnly":"_3DHDH","submit":"_3Ggnd","verification":"_1lCWZ","dash":"_3y6wJ"};